import React from 'react';

const AboutPage = () => (
  <>
    <h2>About us</h2>
    <section className="text-left About">
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque at hic facere impedit
        voluptas cum eveniet ut expedita? Asperiores quis quasi quod magni tenetur atque animi autem
        nihil adipisci cum.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur qui
        libero, numquam tempora ullam atque nesciunt quia consequuntur voluptatum provident laborum
        veritatis blanditiis voluptatem dolore sunt ea recusandae id a. Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Atque at hic facere impedit voluptas cum eveniet ut expedita?
        Asperiores quis quasi quod magni tenetur atque animi autem nihil adipisci cum.Lorem ipsum
        dolor sit amet, consectetur adipisicing elit. Consequatur qui libero, numquam tempora ullam
        atque nesciunt quia consequuntur voluptatum provident laborum veritatis blanditiis
        voluptatem dolore sunt ea recusandae id a. Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Atque at hic facere impedit voluptas cum eveniet ut expedita? Asperiores
        quis quasi quod magni tenetur atque animi autem nihil adipisci cum.Lorem ipsum dolor sit
        amet, consectetur adipisicing elit. Consequatur qui libero, numquam tempora ullam atque
        nesciunt quia consequuntur voluptatum provident laborum veritatis blanditiis voluptatem
        dolore sunt ea recusandae id a.
      </p>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque at hic facere impedit
        voluptas cum eveniet ut expedita? Asperiores quis quasi quod magni tenetur atque animi autem
        nihil adipisci cum.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur qui
        libero, numquam tempora ullam atque nesciunt quia consequuntur voluptatum provident laborum
        veritatis blanditiis voluptatem dolore sunt ea recusandae id a.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque at hic facere impedit
        voluptas cum eveniet ut expedita? Asperiores quis quasi quod magni tenetur atque animi autem
        nihil adipisci cum.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur qui
        libero, numquam tempora ullam atque nesciunt quia consequuntur voluptatum provident laborum
        veritatis blanditiis voluptatem dolore sunt ea recusandae id a.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque at hic facere impedit
        voluptas cum eveniet ut expedita? Asperiores quis quasi quod magni tenetur atque animi autem
        nihil adipisci cum.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur qui
        libero, numquam tempora ullam atque nesciunt quia consequuntur voluptatum provident laborum
        veritatis blanditiis voluptatem dolore sunt ea recusandae id a.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque at hic facere impedit
        voluptas cum eveniet ut expedita? Asperiores quis quasi quod magni tenetur atque animi autem
        nihil adipisci cum.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur qui
        libero, numquam tempora ullam atque nesciunt quia consequuntur voluptatum provident laborum
        veritatis blanditiis voluptatem dolore sunt ea recusandae id a.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque at hic facere impedit
        voluptas cum eveniet ut expedita? Asperiores quis quasi quod magni tenetur atque animi autem
        nihil adipisci cum.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur qui
        libero, numquam tempora ullam atque nesciunt quia consequuntur voluptatum provident laborum
        veritatis blanditiis voluptatem dolore sunt ea recusandae id a.
      </p>
    </section>
  </>
);

export default AboutPage;
